import { render, staticRenderFns } from "./CampaignsFeatures.vue?vue&type=template&id=0f9f5f0c"
import script from "./CampaignsFeatures.vue?vue&type=script&lang=js"
export * from "./CampaignsFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports